import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileService } from 'src/app/services/file.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-card-image-catalogue',
  templateUrl: './card-image-catalogue.component.html',
  styleUrls: ['./card-image-catalogue.component.scss'],
})
export class CardImageCatalogueComponent{
  @Input() options;
  @Output() fileImage = new EventEmitter();
  imageFile;
  defaultImg = environment.defaultImg;

  constructor(
    private fileService: FileService
  ) { }

  async uploadImage(event){
    try{
      const files = (<HTMLInputElement>event.target).files;
      this.imageFile = files[0];
      const res = await this.fileService.uploadImages(files);
      this.options.url = res[0].url;
      this.fileService.emptyArr();
      this.fileImage.emit({ file: this.imageFile, type: this.options.type })
    }catch(err){
      console.error(err);
    }
  }
}
